import React from 'react';
import { Image } from 'views/components/atoms/Image';
import device from 'views/components/molecules/Icon/icons/device.png';
import distribution from 'views/components/molecules/Icon/icons/distribution.png';
import edit from 'views/components/molecules/Icon/icons/edit.png';
import error from 'views/components/molecules/Icon/icons/error.png';
import info from 'views/components/molecules/Icon/icons/info.png';
import mail from 'views/components/molecules/Icon/icons/mail.png';
import pass from 'views/components/molecules/Icon/icons/pass.png';
import user from 'views/components/molecules/Icon/icons/user.png';
import back from 'views/components/molecules/Icon/icons/back.png';
import trash from 'views/components/molecules/Icon/icons/trash.png';
import reply from 'views/components/molecules/Icon/icons/reply.png';
import search from 'views/components/molecules/Icon/icons/search.png';
import close from 'views/components/molecules/Icon/icons/close.png';
import styled from '@emotion/styled';

interface IconWithLabelWrapperProps {
  center?: boolean;
}

const IconWithLabelWrapper = styled.div<IconWithLabelWrapperProps>`
  display: flex;
  justify-content: ${({ center }): string => (center ? 'center' : 'initial')};

  &:not(:first-of-type) {
    margin-top: 2px;
  }
`;

const LabelArea = styled.div`
  margin-left: 6px;
  display: inline;
`;

type IconSize = 'default' | 'small' | 'large';

type WrapperProps = {
  imageSize: IconSize;
};
const Wrapper = styled.div<WrapperProps>`
  width: ${({ imageSize }) => sizeMap[imageSize]};
`;

type IconType =
  | 'device'
  | 'distribution'
  | 'edit'
  | 'error'
  | 'info'
  | 'mail'
  | 'pass'
  | 'user'
  | 'back'
  | 'trash'
  | 'reply'
  | 'search'
  | 'close';

const typeMap = {
  device: device,
  distribution: distribution,
  edit: edit,
  error: error,
  info: info,
  mail: mail,
  pass: pass,
  user: user,
  back: back,
  trash: trash,
  reply: reply,
  search: search,
  close: close,
};

const sizeMap = {
  default: '24px',
  small: '12px',
  large: '44px',
};

interface IconProps {
  type: IconType;
  size?: IconSize;
  label?: React.ReactNode;
  centerWithLabel?: boolean;
  onClick?(): void;
}

export const Icon: React.FC<IconProps> = ({
  type,
  size = 'default',
  label,
  centerWithLabel,
  onClick,
}) => {
  const content = (
    <Wrapper imageSize={size}>
      <Image src={typeMap[type]} alt={type} onClick={onClick} />
    </Wrapper>
  );

  return label ? (
    <IconWithLabelWrapper center={centerWithLabel}>
      {content}
      <LabelArea>{label ? label : null}</LabelArea>
    </IconWithLabelWrapper>
  ) : (
    content
  );
};
